import React, {ReactElement} from 'react';

import SecurityView from './security.view';

const SecurityController = (): ReactElement => {
  return <SecurityView />;
};

export default SecurityController;
